export enum Condition {
  Good = 'Good',
  Fair = 'Fair',
  Poor = 'Poor',
  Disconnected = 'Disconnected'
}
